import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ROUTES } from '../../routes';
import { useAuth } from '../../hooks';
import { MockdLogo } from '../common';
import { TeamSwitcher } from './TeamSwitcher';
import { NotificationBell } from './NotificationBell';
import { ThemeToggle } from './ThemeToggle';

export const Navbar: React.FC = () => {
    const { user, logout, loading: authLoading } = useAuth();
    const navigate = useNavigate();

    const closeMenu = () => (document.activeElement as HTMLElement)?.blur();

    const handleLogout = async () => {
        closeMenu();
        await logout();
        navigate('/');
    }

    return (
        <div className="navbar min-h-14 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 gap-2">
            <div className="navbar-start gap-2">
                <Link
                    className="flex items-center rounded-field px-1 py-2 hover:opacity-80 transition-opacity"
                    to={user ? ROUTES.dashboard() : ROUTES.home()}
                >
                    <MockdLogo size="sm" />
                </Link>
                {!authLoading && user && <TeamSwitcher />}
            </div>
            <div className="navbar-end gap-1">
                {/* Outside the auth gate: signed-out visitors on / and /pricing get it too. */}
                <ThemeToggle />
                {!authLoading && user && <NotificationBell />}
                {!authLoading && (
                    user ? (
                        <div className="dropdown dropdown-end">
                            <div tabIndex={0} role="button" className="btn btn-ghost btn-circle" aria-label="User menu">
                                <div className="avatar avatar-placeholder">
                                    <div className="bg-base-200 text-base-content border border-base-300 w-9 rounded-full">
                                        <span className="text-sm font-medium">{user.email.charAt(0).toUpperCase()}</span>
                                    </div>
                                </div>
                            </div>
                            <ul
                                tabIndex={-1}
                                className="menu menu-sm dropdown-content bg-base-100 border border-base-300 rounded-box z-1 mt-2 w-52 p-2">
                                <li className="menu-title text-xs text-base-content/70 px-2 py-1">{user.email}</li>
                                <li aria-hidden="true" />
                                <li><Link to={ROUTES.account()} onClick={closeMenu}>Account Settings</Link></li>
                                <li><Link to={ROUTES.billing()} onClick={closeMenu}>Billing</Link></li>
                                <li aria-hidden="true" />
                                <li><button type="button" onClick={handleLogout}>Log out</button></li>
                            </ul>
                        </div>
                    ) : (
                        <Link className="btn btn-sm" to={ROUTES.auth.login()}>Log in</Link>
                    )
                )}
            </div>
        </div>
    );
}